import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from './use-theme';

export const useBreakpoints = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.between('xs', 'lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isDesktopLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isDesktopXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isDesktopXxl = useMediaQuery(theme.breakpoints.up('xxl'));
  const isDesktopGs = useMediaQuery(theme.breakpoints.up('gs'));

  return {
    isMobile,
    isTablet,
    isMobileOrTablet,
    isTabletOrMobile,
    isDesktop,
    isDesktopLg,
    isDesktopXl,
    isDesktopXxl,
    isDesktopGs,
  };
};
